import React, { Fragment, useRef, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { useLocation } from '@thd-olt-component-react/router';
import { StickyWithHeaderObserver } from '@thd-olt-component-react/sticky';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { isMobile } from '../../productDetailsUtils';

export const PEPViewProductDetail = ({ sticky = false } ) => {
  const { pathname } = useLocation();
  const pipPath = pathname?.replace(/\/pep\//gi, '/p/');
  const { channel } = useContext(ExperienceContext);
  const detailButtonRef = useRef(null);
  const [showSticky, setShowSticky] = useState(true);

  useEffect(() => {
    if (!sticky || !isMobile(channel) || !detailButtonRef.current) return undefined;
    if (typeof window === 'undefined' || !window.IntersectionObserver) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
          setShowSticky(!entry.isIntersecting ? entry.boundingClientRect.top > 0 : false);
      },
      { threshold: 0 }
    );

    observer.observe(detailButtonRef.current);
    return () => observer.disconnect();
  }, [sticky, channel]);

  return (
    <Fragment>
      {sticky && isMobile(channel) && showSticky && (
        <StickyWithHeaderObserver
          boxShadow
          className="sui-bg-primary sui-left-0 sui-w-full sui-p-4"
          offsetScroll={0}
          position="bottom"
          stickyByDefault
          visibleByDefault
        >
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-w-full see-details"
          >
            <div className="sui-m-0">
              <Button
                fullWidth
                variant="secondary"
                href={pipPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Full Product Details
              </Button>
            </div>
          </div>
        </StickyWithHeaderObserver>
      )}
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className="sui-w-full see-details"
        ref={detailButtonRef}
      >
        <div className="sui-m-0">
          <Button
            fullWidth
            variant="secondary"
            href={pipPath}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Full Product Details
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

PEPViewProductDetail.propTypes = {
  sticky: PropTypes.bool
};

PEPViewProductDetail.displayName = 'PEPViewProductDetail';
